import React from "react";
import Link from "./Link";

const UploadLink = (props) => {
  return <Link upload {...props} />;
};

export default UploadLink;
